import { get, sortBy } from "lodash";
import { resolveLimit } from "utils/helpers/coverageLimits";
import { OPTION_RANKS } from "./constants";

export const coverageSections = (plans) => {
  const sections = {};
  for (const plan of plans || [])
    for (const planCoverage of get(plan, "insurancePlanCoverages") || []) {
      const category = get(planCoverage, "coverageCategory");
      if (!category) continue;
      if (!sections[category.id])
        sections[category.id] = { ...category, benefits: {} };
      for (const mapping of get(planCoverage, "coverageMappings") || []) {
        const benefit = get(mapping, "coverage");
        if (benefit && !sections[category.id].benefits[benefit.id])
          sections[category.id].benefits[benefit.id] = benefit;
      }
    }
  return sortBy(Object.values(sections), "order").map((section) => ({
    ...section,
    benefits: sortBy(Object.values(section.benefits), "order"),
  }));
};

export const limitsByBenefit = (plan) => {
  const limits = {};
  for (const planCoverage of get(plan, "insurancePlanCoverages") || [])
    for (const mapping of get(planCoverage, "coverageMappings") || [])
      if (get(mapping, "coverage.id"))
        limits[mapping.coverage.id] = get(mapping, "limits") || [];
  return limits;
};

export const gridColumns = (combinations, coveragePlansById) =>
  (combinations || []).map((combination) => {
    const plan = get(coveragePlansById, combination.baseInsurancePlanId);
    return {
      rank: combination.id,
      limits: plan ? limitsByBenefit(plan) : null,
      upsellIds: combination.upsellInsurancePlanIds || [],
    };
  });

export const columnValue = (column, benefitId) => {
  if (!column.limits) return null;
  return get(
    resolveLimit(get(column.limits, benefitId), column.upsellIds),
    "value.value",
    null,
  );
};

export const hasAddableOptionColumn = (combinations) => {
  const ids = (combinations || []).map(({ id }) => id);
  return OPTION_RANKS.some((rank) => !ids.includes(rank));
};

export const groupedBenefits = (benefits) => {
  const groups = [];
  (benefits || []).forEach((benefit) => {
    const last = groups[groups.length - 1];
    const subSection = benefit.subtype || null;
    if (last && last.subSection === subSection) {
      last.items.push(benefit);
      return;
    }
    groups.push({ subSection, items: [benefit] });
  });
  return groups;
};
